import LayoutEvents from './LayoutEvents.vue'
export default LayoutEvents



// WEBPACK FOOTER //
// ./src/layouts/layoutEvents/index.js